import React from "react"
import { Facebook, Instagram } from "lucide-mui"
import { XIcon } from "@/shared/x_icon"
import Logo from "@/pages/public/logo"
import i18n from "@/i18n"

const currentYear = new Date().getFullYear()

const STYLES = {
  logo: "w-[105px] h-[26px]",
  tagline: "text-sm",
  taglinePrefix: "text-neutral-300",
  taglineSuffix: "font-semibold text-white",
  taglineDot: "text-neutral-300",
  socialContainer: "flex items-center gap-4",
  socialButton: "cursor-default text-white disabled:opacity-100",
  socialIcon: "w-[13px] h-[13px]",
  xIcon: "w-[13px] h-[13px] fill-current",
} as const

type BrandSectionProps = {
  align: "center" | "start"
}

const BrandSection: React.FC<BrandSectionProps> = ({ align }) => {
  const t = (key: string, opts?: Record<string, unknown>) => i18n.t(`app.public.venue.footer.${key}`, opts)
  const alignClass = align === "center" ? "items-center" : "items-start"

  return (
    <div className={`flex flex-col ${alignClass} gap-4`}>
      <Logo variant="with-icon" className={STYLES.logo} />
      <p className={STYLES.tagline}>
        <span className={STYLES.taglinePrefix}>{t("tagline_prefix")}</span>{" "}
        <span className={STYLES.taglineSuffix}>{t("tagline_suffix")}</span>
        <span className={STYLES.taglineDot}>.</span>
      </p>
      <div className={STYLES.socialContainer}>
        <button type="button" disabled aria-label="Facebook" className={STYLES.socialButton}>
          <Facebook className={STYLES.socialIcon} />
        </button>
        <button type="button" disabled aria-label="Instagram" className={STYLES.socialButton}>
          <Instagram className={STYLES.socialIcon} />
        </button>
        <button type="button" disabled aria-label="X" className={STYLES.socialButton}>
          <XIcon className={STYLES.xIcon} />
        </button>
      </div>
      <p className={`text-xs text-white opacity-70 font-light ${align === "center" ? "mt-2" : "mt-4"}`}>
        {t("copyright", { year: currentYear })}
      </p>
    </div>
  )
}

export default BrandSection
